import fonts from 'fc-styles/src/fonts'
import { prefix } from 'fc-styles'
import { grey, lightGreen, lightGrey, error, white, primary, black } from 'hfty-styles/src/colors'

export const dateTimeTextInputStyle = ({focused}) => ({
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
  borderBottom: '2px solid ' + grey(0.3),
  fontSize: 12,
  marginBottom: 15,
  backgroundColor: 'transparent!important',
})

export const placeholderStyle = ({focused, inline, valid, left = 0}) => ({
  ...fonts.font({size: 12, bold: '500'}),
  width: 0,
  height: 10,
  color: placeholderColor({focused, inline, valid}),
  transition: 'transform 0.05s linear',
  transform: `translateY(${inline ? '37px' : '0px'})`,
  paddingLeft: 10 + left,
  marginBottom: 10,
  whiteSpace: 'nowrap',
})

export const dateTimeRangeInputFocusStyle = (focused) => ({
  backgroundColor: focused ? lightGreen() : lightGrey(),
})

const placeholderColor = ({focused, touched, inline = focused, valid}) => {
  if (touched && !valid) {
    return error(0.8)
  } else if (focused) {
    return grey()
  }

  return grey()
}

export const inputWrapperStyle = () => ({
  display: 'block',
  height: 20,
  paddingLeft: 13,
  zIndex: 4,
  backgroundColor: '#fff',
  borderRadius: 2,
})

export const focusBorder = ({focused, valid, touched}) => prefix({
  height: 2,
  backgroundColor: !valid && touched ? error() : (focused ? lightGreen() : lightGrey()),
  // opacity: (focused || !valid) ? 1 : 0,
  // transform: `scaleX(${(focused || !valid) ? 1 : 0.001})`,
  transition: 'background-color 0.2s linear, opacity 0.1s ease-in, transform 0.2s ease-in',
})

export const floatPlaceHolder = ({focused, inline = false, valid, touched}) => prefix({
  ...fonts.font({size: 12, bold: '500'}),
  position: 'relative',
  pointerEvents: 'none',
  paddingLeft: 10,
  height: 10,
  marginBottom: 10,
  color: placeholderColor({focused, valid, inline, touched}),
  zIndex: '2',
  willChange: 'transform',
  transition: 'transform 0.05s linear',
  transform: `translateY(${inline ? '33px' : '0px'})`,
})

export const basicSelector = prefix({
  position: 'relative',
})

export const DateTimeSelectorStyle = (hasDate) => prefix({
  display: 'inline-block',
  padding: '10px',
  flex: `0 0 ${hasDate ? '100%' : '50%'}`,
})

export const PairDateTimeErrorStyle = prefix({
  padding: 10,
  color: error(),
})

export const DateTimeErrorStyle = prefix({
  color: 'rgba(244, 67, 54, 0.8)',
  marginTop: 10,
})
export const PairDateTimeContainer = (hasDate) => prefix({
  display: 'flex',
  flexDirection: hasDate ? 'column' : 'row',
  flexWrap: 'wrap',
})

// DatePickerPair styles
export const datePickerPair = (viewport, isVertical) => prefix({
  position: 'relative',
  display: 'flex',
  width: viewport.width < 500 || isVertical ? 250 : 500,
  flexWrap: 'wrap',
})

export const dateTimeWrapper = (viewport, isVertical) => prefix({
  // flex: '0 0 ' + (viewport.width < 500 || isVertical ? '100%' : '50%'), // does not work on Firefox
  width: (viewport.width < 500 || isVertical ? 500 : 250),
})

export const dateTimeStyle = (ref, isVertical) => prefix({
  display: isVertical && ref === 'endDatePicker' ? 'none' : 'inline-block',
  backgroundColor: white(),
  position: 'absolute',
  zIndex: 10,
  marginTop: isVertical && ref === 'endDatePicker' ? 278 : 2,
})

export const dateButtonStyle = prefix({
  border: 0,
  backgroundColor: white(),
  outline: 'none',
  boxShadow: 'none',
  fontSize: 12,
  color: grey(0.8),
  margin: 5,
  cursor: 'pointer',
})

export const selectedDateStyle = (config = {}) => prefix({
  backgroundColor: config.isGrey ? grey(0.15) : primary(0.2),
  color: black(),
})

export const firstLastDateStyle = prefix({
  backgroundColor: primary(0.9),
  color: white(),
})

export const hoverDateStyle = prefix({
  backgroundColor: primary(0.2),
  color: black(),
})

export const unselectedDateStyle = prefix({
  backgroundColor: white(),
  color: black(),
})

export const arrowRight = (config = {}) => prefix({
  marginRight: 3,
  marginLeft: -2,
  width: 0,
  height: 0,
  display: 'inline-block',
  borderTop: '6px solid transparent',
  borderBottom: '6px solid transparent',
  borderLeft: `6px solid ${config.isGrey ? grey(0.15) : primary()}`,
})

export const arrowLeft = (config = {}) => prefix({
  marginLeft: 3,
  marginRight: -3,
  width: 0,
  height: 0,
  display: 'inline-block',
  borderTop: '6px solid transparent',
  borderBottom: '6px solid transparent',
  borderRight: `6px solid ${config.isGrey ? grey(0.15) : primary()}`,
})

export const dayBeforeStyle = prefix({
  textAlign: 'right',
})

export const dayAfterStyle = prefix({
  textAlign: 'left',
})

export const clearDateButtonStyle = prefix({
  textAlign: 'center',
  margin: '5px 0',
})

export const disabledDateStyle = prefix({
  backgroundColor: white(),
  color: lightGrey(),
})

export const dateTimeInputWrapper = (hasInput) => prefix({
  marginTop: 10,
  maxWidth: 260,
})

export const textInputStyle = ({focused}) => ({
  position: 'relative',
  width: '100%',
  boxSizing: 'border-box',
  fontSize: 18,
  backgroundColor: 'transparent!important',
})

export const inputStyle = (left = 0) => ({
  ...fonts.font(),
  color: grey(),
  display: 'block',
  width: '100%',
  height: '100%',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  border: 0,
  outline: 'none',
  backgroundColor: 'transparent',
  marginLeft: left,
})
